import React, { createContext, useContext, useState, useEffect } from "react";
import { Navigate } from "react-router-dom";

// Создаем контекст
const AuthContext = createContext(null);

// Хук для использования контекста
export const useAuth = () => useContext(AuthContext);

// Компонент-контейнер для контекста
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const validateToken = async () => {
      if (!token) {
        setIsAuthenticated(false);
        return;
      }

      try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/api/validate-token`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const userData = await response.json();
          console.log(userData)
          setUser(userData.userData); // Сохраняем данные пользователя в состоянии
          setIsAuthenticated(true);
          localStorage.setItem("user", JSON.stringify(userData)); // Сохраняем данные в localStorage
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error("Error validating token:", error);
        setIsAuthenticated(false);
      }
    };

    validateToken();
  }, [token]);

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, setUser, setIsAuthenticated }}>
      {isAuthenticated === null ? <div>Loading...</div> : children}
    </AuthContext.Provider>
  );
};